import { handleGqlResponseBody } from "@/utils/apollo.util";
import {GET_ABOUT_US_PAGINATED_QUERY} from '@/graphql/pages/about-us/about.query';
import {GET_WHY_WE_PAGINATED_QUERY} from '@/graphql/pages/why-we/why-we.query';
import {GET_SKILL_PAGINATED_QUERY} from '@/graphql/pages/skill/skill.query';
import {GET_CONTACT_PAGINATED_QUERY} from '@/graphql/pages/contact/contact.query';
import {GET_FUN_FACT_PAGINATED_QUERY} from '@/graphql/pages/fun-fact/fun-fact.query';
import {GET_SOCIAL_LINK_PAGINATED_QUERY} from '@/graphql/pages/social-link/social-link.query';
import {GET_SERVICE_PAGINATED_QUERY} from '@/graphql/pages/service/service.query';
import {GET_PROJECT_PAGINATED_QUERY} from '@/graphql/pages/project/project.query';
import {GET_TESTIMONIAL_PAGINATED_QUERY} from '@/graphql/pages/testimonial/testimonial.query';
import {GET_FAQ_PAGINATED_QUERY} from '@/graphql/pages/faq/faq.query';
import {GET_STAFF_PAGINATED_QUERY} from '@/graphql/pages/staff/staff.query';
import {GET_FEATURE_PAGINATED_QUERY} from '@/graphql/pages/feature/feature.query';

const pages = {
  actions: {
    async getAboutUsPaginatedQuery({ commit }, { skip, take, orderBy }) {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: GET_ABOUT_US_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
    async getWhyWePaginatedQuery({ commit }, { skip, take, orderBy }) {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: GET_WHY_WE_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
    async getServicePaginatedQuery({ commit }, { skip, take, orderBy }) {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: GET_SERVICE_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
    async getSkillPaginatedQuery({ commit }, { skip, take, orderBy }) {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: GET_SKILL_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
    async getFeaturePaginatedQuery({ commit }, { skip, take, orderBy }) {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: GET_FEATURE_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
    async getContactPaginatedQuery({ commit }, { skip, take, orderBy }) {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: GET_CONTACT_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
    async getFunFactPaginatedQuery({ commit }, { skip, take, orderBy }) {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: GET_FUN_FACT_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
    async getSocialLinkPaginatedQuery({ commit }, { skip, take, orderBy }) {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: GET_SOCIAL_LINK_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
    async getProjectPaginatedQuery({ commit }, { skip, take, orderBy }) {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: GET_PROJECT_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
    async getTestimonialPaginatedQuery({ commit }, { skip, take, orderBy }) {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: GET_TESTIMONIAL_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
    async getFaqPaginatedQuery({ commit }, { skip, take, orderBy }) {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: GET_FAQ_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
    async getStaffPaginatedQuery({ commit }, { skip, take, orderBy }) {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: GET_STAFF_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
  },
};

export default pages;
